const SDK_VERSION = "11.1.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
